var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-4 w-4 md:w-6 md:h-6"},[_c('svg',{staticClass:"fill-current",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }